<h3 class="font-medium mb-2">
  <ng-content></ng-content>
</h3>
